import { BlockStack } from '@shopify/polaris';
import VfsModal from '../../v2/Components/VfsModal';
import { useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { analyticsEventStore, shopStore } from '@/stores';
import { useCallback } from 'react';
import { vfsRoutes } from '@/constants/routes.constants';
import { warningLogo } from '../../assets/images';

export default function LiveLimitAlertModal({ onModalClose }: any) {
    const navigate = useNavigate();
    const { dashboardUrl } = useSnapshot(shopStore);

    const handleClickGetStarted = useCallback(async () => {
        if (!shopStore.enabledFeatures.includes('live')) return;
        analyticsEventStore.goLiveClickedEvent();
        open(`${shopStore.dashboardUrl}`, '_blank');
    }, [dashboardUrl]);

    return (
        <VfsModal
            onCloseModal={onModalClose}
            primaryAction={() => navigate(vfsRoutes.managePlans)}
            primaryActionText="Upgrade"
            secondaryAction={handleClickGetStarted}
            secondaryActionText="Continue with Test Live"
            modalWidth="36rem"
            crossIcon
            title=""
        >
            <BlockStack align="center" gap="200" inlineAlign="center">
                <img
                    src={warningLogo}
                    alt="Warning"
                    style={{ marginBottom: '15px' }}
                />
                <p
                    style={{
                        fontSize: '28px',
                        fontWeight: 700,
                        marginBottom: '20px',
                    }}
                >
                    You have reached your live limit
                </p>
                <p style={{ textAlign: 'center', fontSize: '15px' }}>
                    Your plan includes 1 live selling event per month. Upgrade
                    to unlock unlimited live selling and boost your sales
                    without limits 🎉
                </p>
                <p style={{ textAlign: 'center', fontSize: '15px' }}>
                    Test lives are unlimited and do not count towards your
                    monthly limit.
                </p>
            </BlockStack>
        </VfsModal>
    );
}
